const menu = {
  key: "countries",
  route: "/legacy/countries",
  label: "sidebar.countries",
  icon: "faGlobe",
  group: "masterdata",
  order: 20,
  permission: "legacy.countries.read"
};

export default menu;